import { Collapse } from '@shape-ds/components';
import { Evidences } from 'components/Evidences/Evidences';
import { useEvidencesHook } from 'components/Evidences/hooks/useEvidencesHook';
import { useTabs } from 'hooks/useTabs';
import { RecordsMessages } from 'pages/Asset/tabs/Events/components/Records';
import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CollapseActionButton, CollapseTitle, TooltipType } from '../Collapse/CollapseTitle';
import { RelatedAlarmsForm } from '../RelatedAlarms/RelatedAlarmsForm';
import { useRelatedAlarmHook } from '../RelatedAlarms/useRelatedAlarmHook';
import './TabsCard.scss';

interface Props {
  open?: boolean;
  isFormDisabled?: boolean;
}

interface TabsProperties {
  name: string;
  label: string;
  button?: CollapseActionButton;
  customElement?: React.ReactNode;
  tooltip?: TooltipType;
}

interface Tabs {
  [key: string]: TabsProperties;
}

export function TabsCard({ open = true, isFormDisabled }: Props) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(open);

  const { fileInputRef, ...evidencesTab } = useEvidencesHook();

  const TABS: Tabs = {
    relatedAlarms: useRelatedAlarmHook(),
    evidences: {
      name: evidencesTab.name,
      label: evidencesTab.label,
      button: evidencesTab.button,
      tooltip: evidencesTab.tooltip,
    },
    records: {
      name: 'records',
      label: t('case:tabs.records'),
    },
  };
  const caseId = useWatch({ name: 'id' });

  const { activeTab, tabsComponent } = useTabs({
    tabNames: Object.keys(TABS),
    getLabel: (tab) => TABS[tab].label,
  });

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <Collapse
      title={
        <CollapseTitle
          title={tabsComponent}
          {...TABS[activeTab]}
          name="cases-tabs-card"
          disabled={isFormDisabled}
        />
      }
      toggleIsOpen={() => setIsOpen((prev) => !prev)}
      isOpen={isOpen}
      cursorPointerOnArrowOnly
    >
      {activeTab === TABS.relatedAlarms.name && <RelatedAlarmsForm />}
      {activeTab === TABS.evidences.name && <Evidences fileInputRef={fileInputRef} />}
      {activeTab === TABS.records.name && <RecordsMessages eventId={caseId} disableFiles />}
    </Collapse>
  );
}
